export default __webpack_public_path__ + "static/f98f1410-b6b5-4272-b29c-214865f3740e-614d16c264205329eb1cd0b5c2df7cc6.woff";